import { render } from "./ranking-table.vue?vue&type=template&id=9816e750&scoped=true"
import script from "./ranking-table.vue?vue&type=script&lang=ts"
export * from "./ranking-table.vue?vue&type=script&lang=ts"

import "./ranking-table.vue?vue&type=style&index=0&id=9816e750&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9816e750"

export default script